import PropTypes from "prop-types"
import { connect } from "react-redux"

import Modal from "components/modal"
import Image from "components/ui/image"

const PreviewImageModal = ({ previewImage }) => {
  if (!previewImage) return null

  return (
    <Modal
      contentClassName="text-center"
      headerClassName="px-16 pt-16"
      headerVariant="inline"
      height="fit-content"
      label="Preview Design"
      labelClassName="mt-0"
      modalType="popup"
      show="#preview"
      width="100%"
    >
      <Image
        alt="Product preview"
        className="mx-auto w-full"
        height="500"
        sizes="100vw"
        src={previewImage.src}
        srcSet={previewImage.srcSet}
        width="500"
      />
    </Modal>
  )
}

PreviewImageModal.propTypes = {
  previewImage: PropTypes.object,
}

const mapStateToProps = (state) => {
  const allViews = state.previewImage.data?.all_views || []
  const slides = state.previewImage.data?.images || []
  const previewSlide = Object.entries(slides).find(([view]) =>
    allViews.includes(view.replace("_view", ""))
  )

  return {
    previewImage: previewSlide ? previewSlide[1] : null,
  }
}

export default connect(mapStateToProps)(PreviewImageModal)
